import { Filters } from "./components/filters/filters";
import { Header } from "./components/header/header";
import { ProductResultList } from "./components/resultList/productResultList";
import { SelectedFacets } from "./components/selectedFacets/selectedFacets.container";
import { Base } from "./resultsView.base";

export const ResultsView = Object.assign(Base, {
    Filters: Filters,
    Header: Header,
    SelectedFacets: SelectedFacets,
    ResultList: ProductResultList
});
